export default class UserOrderStatistics {
    totalOrderNums: number;
    completeOrderNums: number;
    outstandingOrderNums: number;
    residualIntegral: number;
}